import { ErrorScreen } from "@lending/components/ErrorScreen/ErrorScreen";
import { ProductSelection } from "@lending/pages/ProductSelection";
import { useProductSelectionContainer } from "../pages/ProductSelection/hooks/useProductSelectionContainer";

function ProductSelectionRedirect() {
  const { showPersonalLoanOption, showCreditCardOption, showAutoLoanOption } =
    useProductSelectionContainer();

  const hasAnyProduct = showPersonalLoanOption || showCreditCardOption || showAutoLoanOption;

  if (!hasAnyProduct) {
    console.error("No lending products are available for the institution.");
    return <ErrorScreen />;
  }

  // No single-product shortcut: the Loan Portal tile lives on this page, so
  // returning applicants need it rendered even when one product is offered.
  return <ProductSelection />;
}

export { ProductSelectionRedirect };
